export default __webpack_public_path__ + "static/media/workspace_user.7c1544ca.csv";